/**
 * errCode_list中包含的后端错误Code对应文案由前端特殊处理及展示
 */
const Constant = {
  errCode_list: {
    CT_ids_login_fail: '网络异常，请重新登录',
    idaas_login_fail: '网络异常，请重新登录',
    idaas_modify_pass_fail: '网络异常，请稍后重试',
    idaas_login_fail_getDealerApps: '网络异常，请稍后重试',
    idaas_get_applist_fail: '网络异常，请重新登录',
    idaas_common_illegal: '网络异常，请重新登录'
  },
  tp_list: [
    'TYREPLUS',
    'FDD'
  ]
}

export default Constant
